/* eslint-disable vymo-ui/restrict-import */
import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getRevyreWorkflowConfig } from 'src/models/lmsConfig/queries';
import { getState } from 'src/store';
import { isDev } from 'src/workspace/utils';
import { getWorkflowMetaData } from '../selector';
import {
  addMessage,
  clearStore,
  setIsLoading,
  setIsTyping,
  setWorkflowMetaData,
} from '../slice';
import { Message, MESSAGE_TYPE } from '../types';

const baseURL = isDev()
  ? 'http://localhost:3000'
  : 'https://frontend.getvymo.com';

export const sendMessage = createAsyncThunk(
  'sendMessage',
  async (
    { text, metadata: metadataProp, chatSessionId }: any,
    { dispatch },
  ) => {
    try {
      dispatch(setIsLoading(true));
      const newMessage: Message = {
        sender: 'USER',
        message_type: MESSAGE_TYPE.TEXT,
        text,
      };
      dispatch(addMessage(newMessage));
      dispatch(setIsTyping(true));

      const metadata = getWorkflowMetaData(getState());
      const config = getRevyreWorkflowConfig();
      const { data: response }: any = await axios.post(
        `${baseURL}/frontend/api/agentic`,
        {
          query: text,
          chatSessionId,
          metadata: {
            ...metadata,
            ...metadataProp,
            modulesConfig: config,
          },
        },
        {
          headers: {
            'x-frontendboard-token': process.env.X_FRONTEND_TOKEN,
          },
        },
      );
      dispatch(setWorkflowMetaData(response?.metadata || {}));
      dispatch(addMessage(response));
      dispatch(setIsLoading(false));
      dispatch(setIsTyping(false));
    } catch (error) {
      dispatch(setIsLoading(false));
      dispatch(setIsTyping(false));
    }
  },
);

const onActivate = () => {};
const onDeactivate = ({ dispatch }) => {
  dispatch(clearStore());
};

export default { onActivate, onDeactivate };
